import { render, staticRenderFns } from "./UpdateTeamConfig.vue?vue&type=template&id=44993326&"
import script from "./UpdateTeamConfig.vue?vue&type=script&lang=js&"
export * from "./UpdateTeamConfig.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTeamConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports